import type { Domino } from "../vision";

/** In some games a double-blank (0,0) is worth this many points. */
export const DOUBLE_BLANK_SCORE = 50;

export interface ScoringOptions {
  /** When true, a double-blank (0,0) domino scores {@link DOUBLE_BLANK_SCORE}. */
  doubleBlankIs50: boolean;
}

export const DEFAULT_SCORING: ScoringOptions = { doubleBlankIs50: true };

/** Whether a domino is a double-blank (both halves show zero pips). */
export function isDoubleBlank(domino: Pick<Domino, "values">): boolean {
  return domino.values[0] === 0 && domino.values[1] === 0;
}

/**
 * Score a single domino. This is the same as its pip total, except that under
 * the optional house rule a double-blank is worth {@link DOUBLE_BLANK_SCORE}.
 */
export function scoreDomino(
  domino: Pick<Domino, "values" | "total">,
  options: ScoringOptions = DEFAULT_SCORING,
): number {
  if (options.doubleBlankIs50 && isDoubleBlank(domino)) {
    return DOUBLE_BLANK_SCORE;
  }
  return domino.total;
}

/** Sum the scores of every domino in the group under the given rules. */
export function scoreTotal(
  dominoes: ReadonlyArray<Pick<Domino, "values" | "total">>,
  options: ScoringOptions = DEFAULT_SCORING,
): number {
  return dominoes.reduce((sum, d) => sum + scoreDomino(d, options), 0);
}
